/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UserFeedbackRouteImport } from './routes/user-feedback'
import { Route as UserRouteImport } from './routes/user'
import { Route as GuidanceRouteImport } from './routes/guidance'
import { Route as AboutRouteImport } from './routes/about'
import { Route as MyChimneyContextRouteImport } from './routes/_myChimneyContext'
import { Route as MyChimneyContextIndexRouteImport } from './routes/_myChimneyContext.index'
import { Route as MyChimneyContextSummaryRouteImport } from './routes/_myChimneyContext.summary'
import { Route as MyChimneyContextHistoryRouteImport } from './routes/_myChimneyContext.history'
import { Route as MyChimneyContextCombustionPlantRouteImport } from './routes/_myChimneyContext.combustion-plant'
import { Route as MyChimneyContextBurnsRouteImport } from './routes/_myChimneyContext.burns'

const UserFeedbackRoute = UserFeedbackRouteImport.update({
  id: '/user-feedback',
  path: '/user-feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const UserRoute = UserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => rootRouteImport,
} as any)
const GuidanceRoute = GuidanceRouteImport.update({
  id: '/guidance',
  path: '/guidance',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const MyChimneyContextRoute = MyChimneyContextRouteImport.update({
  id: '/_myChimneyContext',
  getParentRoute: () => rootRouteImport,
} as any)
const MyChimneyContextIndexRoute = MyChimneyContextIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MyChimneyContextRoute,
} as any)
const MyChimneyContextSummaryRoute = MyChimneyContextSummaryRouteImport.update({
  id: '/summary',
  path: '/summary',
  getParentRoute: () => MyChimneyContextRoute,
} as any)
const MyChimneyContextHistoryRoute = MyChimneyContextHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => MyChimneyContextRoute,
} as any)
const MyChimneyContextCombustionPlantRoute =
  MyChimneyContextCombustionPlantRouteImport.update({
    id: '/combustion-plant',
    path: '/combustion-plant',
    getParentRoute: () => MyChimneyContextRoute,
  } as any)
const MyChimneyContextBurnsRoute = MyChimneyContextBurnsRouteImport.update({
  id: '/burns',
  path: '/burns',
  getParentRoute: () => MyChimneyContextRoute,
} as any)

export interface FileRoutesByFullPath {
  '/about': typeof AboutRoute
  '/guidance': typeof GuidanceRoute
  '/user': typeof UserRoute
  '/user-feedback': typeof UserFeedbackRoute
  '/burns': typeof MyChimneyContextBurnsRoute
  '/combustion-plant': typeof MyChimneyContextCombustionPlantRoute
  '/history': typeof MyChimneyContextHistoryRoute
  '/summary': typeof MyChimneyContextSummaryRoute
  '/': typeof MyChimneyContextIndexRoute
}
export interface FileRoutesByTo {
  '/about': typeof AboutRoute
  '/guidance': typeof GuidanceRoute
  '/user': typeof UserRoute
  '/user-feedback': typeof UserFeedbackRoute
  '/burns': typeof MyChimneyContextBurnsRoute
  '/combustion-plant': typeof MyChimneyContextCombustionPlantRoute
  '/history': typeof MyChimneyContextHistoryRoute
  '/summary': typeof MyChimneyContextSummaryRoute
  '/': typeof MyChimneyContextIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_myChimneyContext': typeof MyChimneyContextRouteWithChildren
  '/about': typeof AboutRoute
  '/guidance': typeof GuidanceRoute
  '/user': typeof UserRoute
  '/user-feedback': typeof UserFeedbackRoute
  '/_myChimneyContext/burns': typeof MyChimneyContextBurnsRoute
  '/_myChimneyContext/combustion-plant': typeof MyChimneyContextCombustionPlantRoute
  '/_myChimneyContext/history': typeof MyChimneyContextHistoryRoute
  '/_myChimneyContext/summary': typeof MyChimneyContextSummaryRoute
  '/_myChimneyContext/': typeof MyChimneyContextIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/about'
    | '/guidance'
    | '/user'
    | '/user-feedback'
    | '/burns'
    | '/combustion-plant'
    | '/history'
    | '/summary'
    | '/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/about'
    | '/guidance'
    | '/user'
    | '/user-feedback'
    | '/burns'
    | '/combustion-plant'
    | '/history'
    | '/summary'
    | '/'
  id:
    | '__root__'
    | '/_myChimneyContext'
    | '/about'
    | '/guidance'
    | '/user'
    | '/user-feedback'
    | '/_myChimneyContext/burns'
    | '/_myChimneyContext/combustion-plant'
    | '/_myChimneyContext/history'
    | '/_myChimneyContext/summary'
    | '/_myChimneyContext/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  MyChimneyContextRoute: typeof MyChimneyContextRouteWithChildren
  AboutRoute: typeof AboutRoute
  GuidanceRoute: typeof GuidanceRoute
  UserRoute: typeof UserRoute
  UserFeedbackRoute: typeof UserFeedbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/user-feedback': {
      id: '/user-feedback'
      path: '/user-feedback'
      fullPath: '/user-feedback'
      preLoaderRoute: typeof UserFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user': {
      id: '/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof UserRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guidance': {
      id: '/guidance'
      path: '/guidance'
      fullPath: '/guidance'
      preLoaderRoute: typeof GuidanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_myChimneyContext': {
      id: '/_myChimneyContext'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof MyChimneyContextRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_myChimneyContext/': {
      id: '/_myChimneyContext/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MyChimneyContextIndexRouteImport
      parentRoute: typeof MyChimneyContextRoute
    }
    '/_myChimneyContext/summary': {
      id: '/_myChimneyContext/summary'
      path: '/summary'
      fullPath: '/summary'
      preLoaderRoute: typeof MyChimneyContextSummaryRouteImport
      parentRoute: typeof MyChimneyContextRoute
    }
    '/_myChimneyContext/history': {
      id: '/_myChimneyContext/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof MyChimneyContextHistoryRouteImport
      parentRoute: typeof MyChimneyContextRoute
    }
    '/_myChimneyContext/combustion-plant': {
      id: '/_myChimneyContext/combustion-plant'
      path: '/combustion-plant'
      fullPath: '/combustion-plant'
      preLoaderRoute: typeof MyChimneyContextCombustionPlantRouteImport
      parentRoute: typeof MyChimneyContextRoute
    }
    '/_myChimneyContext/burns': {
      id: '/_myChimneyContext/burns'
      path: '/burns'
      fullPath: '/burns'
      preLoaderRoute: typeof MyChimneyContextBurnsRouteImport
      parentRoute: typeof MyChimneyContextRoute
    }
  }
}

interface MyChimneyContextRouteChildren {
  MyChimneyContextBurnsRoute: typeof MyChimneyContextBurnsRoute
  MyChimneyContextCombustionPlantRoute: typeof MyChimneyContextCombustionPlantRoute
  MyChimneyContextHistoryRoute: typeof MyChimneyContextHistoryRoute
  MyChimneyContextSummaryRoute: typeof MyChimneyContextSummaryRoute
  MyChimneyContextIndexRoute: typeof MyChimneyContextIndexRoute
}

const MyChimneyContextRouteChildren: MyChimneyContextRouteChildren = {
  MyChimneyContextBurnsRoute: MyChimneyContextBurnsRoute,
  MyChimneyContextCombustionPlantRoute: MyChimneyContextCombustionPlantRoute,
  MyChimneyContextHistoryRoute: MyChimneyContextHistoryRoute,
  MyChimneyContextSummaryRoute: MyChimneyContextSummaryRoute,
  MyChimneyContextIndexRoute: MyChimneyContextIndexRoute,
}

const MyChimneyContextRouteWithChildren =
  MyChimneyContextRoute._addFileChildren(MyChimneyContextRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  MyChimneyContextRoute: MyChimneyContextRouteWithChildren,
  AboutRoute: AboutRoute,
  GuidanceRoute: GuidanceRoute,
  UserRoute: UserRoute,
  UserFeedbackRoute: UserFeedbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
